import React from 'react'
import computer from '../assets/icons/computer.png'
import phone from '../assets/icons/phone.png'
import tablet from '../assets/icons/tablet.png'
import tv from '../assets/icons/tv.png'
import { NavLink } from 'react-router-dom'
import { ubiznewsFacebook, ubiznewsInstagram, ubiznewsLinkedIn, ubiznewsYoutube } from '../constants/links'

const DevicesList = () => {
    return (
        <div className='row justify-content-center align-items-center w-auto mb-2'>
            {/* images */}
            <div className=' col-12 row justify-content-center align-items-center gx-lg-2'>
                <NavLink target='_BLANK' to={ubiznewsFacebook} className='col-auto mt-2'>
                    <img src={computer} alt='computer' className='img-fluid devices-img'/>
                </NavLink>
                <NavLink target='_BLANK' to={ubiznewsInstagram} className='col-auto mt-2'>
                    <img src={phone} alt='phone' className='img-fluid devices-img'/>
                </NavLink>
                <NavLink target='_BLANK' to={ubiznewsLinkedIn} className='col-auto mt-2'>
                    <img src={tablet} alt='tablet' style={{height:'1.5rem'}} className='img-fluid devices-img'/>
                </NavLink>
                <NavLink target='_BLANK' to={ubiznewsYoutube} className='col-auto mt-2'>
                    <img src={tv} alt='tv' className='img-fluid devices-img'/>
                </NavLink>
            </div>
            {/* text */}
            <div className=' col-12 text-center mx-auto mt-3 gx-lg-1'>
                <div className='fw-bold text-uppercase'>UBIZNEWS TV sur tous vos écrans</div>
                <div className='fs-8s'>Retrouvez nos programmes sur ordinateur, smartphone, tablette ou TV connectée</div>
            </div>
        </div>
    )
}

export default DevicesList